import { type ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import CopyButton from '../ui/CopyButton';

/* Section de résultat avec bouton « copier » au survol.
 * Extrait tel quel de ResultsDisplay.tsx. */

export default function SectionBlock({ children, className, copyText }: { children: ReactNode; className: string; copyText: string }) {
  const { features } = useAuth();
  const canCopy = features.copyText;
  return (
    <section className={`group/section relative ${className}`}>
      {canCopy && (
        <div className="absolute top-3 right-3 opacity-0 group-hover/section:opacity-100 transition-opacity duration-200">
          <CopyButton text={copyText} />
        </div>
      )}
      {children}
    </section>
  );
}
